import { z } from "zod";
import { baseRoute } from "./photography";
import api from "@/lib/axiosConfig";

export const photographySchema = z.object({
  id: z.string().optional(),
  photosDescriptionNumeroEnregistrement: z
    .string()
    .nonempty("form.error.emptyField"),
  photosDescriptionTitre: z.string(),
});

export const appendNoDuplicateRecordNumberRefine = <
  T extends {
    id?: string;
    photosDescriptionNumeroEnregistrement: string;
  },
>(
  schema: z.ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateRecordNumbers(
        val.photosDescriptionNumeroEnregistrement,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: "form.error.photography.duplicateRecordNumbers",
      path: ["photosDescriptionNumeroEnregistrement"],
    },
  );

export async function validateNoDuplicateRecordNumbers(
  recordNumber: string,
  id?: string,
) {
  await api.get<void>(`${baseRoute}/record-number/validate/no-duplicates`, {
    params: {
      value: recordNumber,
      id,
    },
  });
}
